import React, { useEffect } from "react";
import bgImage from "../../Assets/loginpage.jpg";
import LoginForm from "./LoginForm";
import { Preferences } from "@capacitor/preferences";
import toast from "react-hot-toast";
import { MESSAGES } from "./Constants";

const Login = () => {
  useEffect(() => {
    const checkSessionExpired = async () => {
      const { value } = await Preferences.get({ key: "sessionExpired" });
      if (value === "1") {
        toast.error(MESSAGES.SESSION_TIMEOUT);
        await Preferences.remove({ key: "sessionExpired" });
      }
    };

    checkSessionExpired();
  }, []);

  return (
    <div>
      <LoginForm />
    </div>
  );
};

export default Login;
